import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';


export default function FilterCustomerCrewList(props) {
    //console.debug("RTS Break LoadListFilterCrewList");

    const [isLoading, setIsLoading] = useState(true);
    
    const [crews, setCrews] = useState();
    const [repoCrews, setRepoCrews] = useState();


    useEffect(() => {
        if(props.crews===null){
            setCrews([]);
        }
        else{
            setCrews(props.crews);
        }

        if(props.data == null){
            setRepoCrews(["Not Assigned"]);
        }
        else{
            setRepoCrews(props.data);
        }

        setIsLoading(false);
    }, [props]);
    
    
    function valChange(e, val){
        props.setCrewsFx(val);
        setCrews(val);
    }


    if(isLoading){
        return(
            <Loading />
        );
    }
    

    return(
        <>
            <Autocomplete
                options={repoCrews}
                renderInput={(params) => <TextField {...params} label="Crews" size="small" />}
                value={crews}
                onChange={valChange}
                multiple
            />
        </>
    );
}


